export enum MixpanelSuperProperties {
  ESTATE_NAME = 'estateName'
}
